<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    width="64"
    height="64"
    viewBox="0 0 172 172"
    fill="currentColor"
  >
    <g
      fill="none"
      fill-rule="nonzero"
      stroke="none"
      stroke-width="1"
      stroke-linecap="butt"
      stroke-linejoin="miter"
      stroke-miterlimit="10"
      stroke-dasharray=""
      stroke-dashoffset="0"
      font-family="none"
      font-weight="none"
      font-size="none"
      text-anchor="none"
      style="mix-blend-mode: normal"
    >
      <path d="M0,172v-172h172v172z" fill="none"></path>
      <g fill="currentColor">
        <path
          d="M84.65625,51.0625v43c0,2.28437 1.74688,4.03125 4.03125,4.03125c2.28437,0 4.03125,-1.74688 4.03125,-4.03125v-43c0,-9.1375 -7.12188,-16.6625 -16.125,-17.33438v-1.47812c0,-9.675 -7.79375,-17.46875 -17.46875,-17.46875c-9.675,0 -17.46875,7.79375 -17.46875,17.46875v94.86875c0,8.86875 2.15,17.87188 6.04688,25.8l7.79375,15.5875c0.67188,1.34375 2.01563,2.28438 3.62813,2.28438c1.6125,0 2.95625,-0.80625 3.62813,-2.28438l7.79375,-15.5875c4.03125,-7.92812 6.04688,-16.93125 6.04688,-25.8v-85.32812c4.56875,0.67188 8.0625,4.56875 8.0625,9.27188zM68.53125,127.11875c0,7.65937 -1.88125,15.31875 -5.24063,22.17188l-4.16562,8.33125l-4.16562,-8.33125c-3.35937,-6.85313 -5.24063,-14.5125 -5.24063,-22.17188v-94.86875c0,-5.24062 4.16562,-9.40625 9.40625,-9.40625c5.24062,0 9.40625,4.16563 9.40625,9.40625zM90.03125,162.59375h-6.71875c-2.28437,0 -4.03125,1.74687 -4.03125,4.03125c0,2.28438 1.74688,4.03125 4.03125,4.03125h6.71875c2.28437,0 4.03125,-1.74687 4.03125,-4.03125c0,-2.28438 -1.88125,-4.03125 -4.03125,-4.03125zM167.29688,160.44375c-1.6125,-1.6125 -4.16563,-1.6125 -5.64375,0c-1.20937,1.20938 -2.82187,1.74688 -4.43437,1.47813c-1.6125,-0.26875 -2.95625,-1.20937 -3.7625,-2.6875l-4.03125,-7.65938c-1.88125,-3.49375 -5.50938,-5.50937 -9.40625,-5.10625c-3.89688,0.40312 -7.12188,2.95625 -8.33125,6.71875l-2.82188,9.00313c0,0.13437 -0.13437,0.26875 -0.40312,0.26875c-0.26875,0 -0.40312,-0.13437 -0.40312,-0.26875l-1.20938,-2.28438c-1.47812,-2.82188 -4.16562,-4.56875 -7.25625,-4.70312c-3.09063,-0.13438 -6.04687,1.47813 -7.79375,4.16563l-3.89687,4.56875c-1.47813,1.74687 -1.20938,4.3 0.40312,5.64375c0.80625,0.67188 1.74688,0.94062 2.55313,0.94062c1.075,0 2.28437,-0.5375 3.09063,-1.47812l4.03125,-4.70312c0.13437,-0.13438 0.26875,-0.40312 0.40312,-0.5375c0.26875,-0.40312 0.5375,-0.5375 0.80625,-0.5375c0,0 0.13437,0 0.26875,0.26875l1.20938,2.28437c1.6125,3.09063 4.8375,4.97188 8.33125,4.70313c3.49375,-0.26875 6.45,-2.55312 7.39063,-5.9125l2.82188,-9.00313c0.26875,-0.94062 0.94062,-1.075 1.34375,-1.075c0.40312,0 1.20937,0 1.6125,0.80625l4.03125,7.65937c2.01563,3.7625 5.50938,6.18125 9.675,6.85313c4.16563,0.67188 8.33125,-0.67187 11.2875,-3.7625c1.6125,-1.47813 1.6125,-4.03125 0.13438,-5.64375z"
        ></path>
      </g>
    </g>
  </svg>
</template>

<script>
export default {};
</script>

<style>
</style>